export const enUS = {
  general: {
    days: 'd',
    subscribe: 'Subscribe',
    unlimitedSubscription: 'Unlimited subscription',
    prolongateSubscription: 'Click to prolongate subscription',
  },
  hints: {
    chartLoadError: 'Error loading chart data.',
  },
  buttons: {
    goToMain: 'Back to main',
  },
  generalInfo: {
    title: 'Daily target',
    goals: {
      loss: 'Weight loss',
      gain: 'Weight gain',
      maintain: 'Maintenance',
    },
    nutrients: {
      calories: 'Calories',
      proteins: 'Proteins',
      fats: 'Fats',
      carbs: 'Carbs',
    },
    units: {
      kcal: 'kcal',
      g: 'g',
    },
    status: {
      remaining: '{{value}} left',
      exceeded: '{{value}} over',
    },
    toStats: 'View statistics',
    error: {
      target: 'Failed to load your daily target. Please try again later.',
    },
    noTarget: 'No daily target set yet. You can set it via the bot',
  },
  graphStats: {
    title: 'Nutrition statistics',
    modes: {
      today: 'Today',
      period: 'Period',
    },
    metrics: {
      calories: 'Calories',
      proteins: 'Proteins',
      fats: 'Fats',
      carbs: 'Carbs',
    },
    compareWithYesterday: 'Compare with yesterday',
    periods: {
      week: 'Week',
      twoWeeks: '2 weeks',
      month: 'Month',
    },
    series: {
      today: 'Today',
      yesterday: 'Yesterday',
      target: 'Target',
    },
    mealTypes: {
      breakfast: 'Breakfast',
      morning_snack: 'Morning snack',
      lunch: 'Lunch',
      afternoon_snack: 'Afternoon snack',
      dinner: 'Dinner',
      evening_snack: 'Evening snack',
      unknown: 'Other',
    },
    empty: {
      today: 'No meals logged for today yet.',
      period: 'No meals logged for this period.',
    },
    units: {
      kcal: 'kcal',
      g: 'g',
    },
    error: {
      meals: 'Failed to load meals data. Please try again later.',
      target: 'Failed to load your daily target. Please try again later.',
    },
  },
  meal: {
    mealTypes: {
      breakfast: 'Breakfast',
      morning_snack: 'Morning snack',
      lunch: 'Lunch',
      afternoon_snack: 'Afternoon snack',
      dinner: 'Dinner',
      evening_snack: 'Evening snack',
      unknown: 'Other',
    },
    nutrients: {
      proteins: 'Proteins',
      fats: 'Fats',
      carbs: 'Carbs',
    },
    macroShort: {
      proteins: 'P',
      fats: 'F',
      carbs: 'C',
    },
    units: {
      kcal: 'kcal',
      g: 'g',
    },
    edited: 'edited',
    items: {
      title: 'Composition',
      empty: 'No items in this meal.',
    },
    editTitle: 'Edit meal',
    form: {
      title: 'Title',
      description: 'Description',
      type: 'Meal type',
      itemName: 'Item name',
      totals: 'Totals',
    },
    buttons: {
      edit: 'Edit meal',
      delete: 'Delete meal',
      save: 'Save changes',
      cancel: 'Cancel',
      addItem: 'Add item',
      confirmDelete: 'Delete',
    },
    deleteConfirm: {
      question: 'Delete this meal?',
      hint: 'This action cannot be undone.',
    },
    success: {
      update: 'Meal updated.',
      delete: 'Meal deleted.',
    },
    error: {
      load: 'Failed to load the meal. Please try again later.',
      update: 'Failed to save changes. Please try again later.',
      delete: 'Failed to delete the meal. Please try again later.',
    },
  },
  mealsList: {
    title: 'Meals',
    today: 'Today',
    pickDate: 'Pick a date',
    weekdays: {
      0: 'Sun',
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat',
    },
    mealTypes: {
      breakfast: 'Breakfast',
      morning_snack: 'Morning snack',
      lunch: 'Lunch',
      afternoon_snack: 'Afternoon snack',
      dinner: 'Dinner',
      evening_snack: 'Evening snack',
      unknown: 'Meal',
    },
    macroShort: {
      proteins: 'P',
      fats: 'F',
      carbs: 'C',
    },
    units: {
      kcal: 'kcal',
    },
    total: 'Total',
    empty: 'No meals logged for this day.',
    error: {
      meals: 'Failed to load meals data. Please try again later.',
    },
  },
}
